import { ActivatedRouteSnapshot, ViewTransitionInfo } from '@angular/router';

export const appViewTransitionOptions = {
  onViewTransitionCreated: ({ transition, to, from }: ViewTransitionInfo) => {
    const getAnim = (snap: ActivatedRouteSnapshot) => snap.root.firstChild?.data?.['animation'] ?? null;
    const toAnim = getAnim(to);
    const fromAnim = getAnim(from);

    const toPath = to.root.firstChild?.routeConfig?.path;
    const fromPath = from.root.firstChild?.routeConfig?.path;

    if (toPath === fromPath) {
      transition.skipTransition();
      return;
    }

    const root = document.documentElement;
    root.classList.remove('slide-forward', 'slide-backward', 'fade');

    if (toAnim !== null && fromAnim !== null) {
      if (toAnim > fromAnim) {
        root.classList.add('slide-forward');
      } else if (toAnim < fromAnim) {
        root.classList.add('slide-backward');
      }
    } else {
      root.classList.add('fade');
    }

    transition.finished.finally(() => {
      root.classList.remove('slide-forward', 'slide-backward', 'fade');
    });
  }
};
